import { Link } from "react-router-dom";

/**
 * AuthenticatedFooter — compact 1-line footer for the dashboard shell.
 * Keeps the marketing footer out of the app while giving users
 * permanent access to Privacy · Terms · Security · Support · Status.
 */
export default function AuthenticatedFooter() {
    const year = new Date().getFullYear();
    return (
        <footer
            className="af-root"
            data-testid="authenticated-footer"
            style={{
                display: "flex", alignItems: "center", justifyContent: "space-between",
                gap: 16, flexWrap: "wrap",
                padding: "14px 24px",
                borderTop: "1px solid var(--border, rgba(0,0,0,0.06))",
                fontSize: 12,
                color: "var(--muted-foreground, rgba(0,0,0,0.55))",
            }}
        >
            <div>&copy; {year} VAULT · Created by PD</div>
            <nav aria-label="Legal & support" style={{ display: "flex", gap: 14, flexWrap: "wrap" }}>
                <Link to="/privacy" data-testid="af-privacy" className="hover:underline">Privacy</Link>
                <Link to="/terms" data-testid="af-terms" className="hover:underline">Terms</Link>
                <Link to="/security" data-testid="af-security" className="hover:underline">Security</Link>
                <Link to="/support" data-testid="af-support" className="hover:underline">Support</Link>
                <Link to="/status" data-testid="af-status" className="hover:underline">Status</Link>
            </nav>
        </footer>
    );
}
